import favIcon from "assets/icons/favicon.ico";

export default {
  defaultTitle: "StandbyMD",
  titleTemplate: "%s | StandbyMD",
  meta: [{ name: "description", content: "StandbyMD" }],
  link: [
    {
      rel: "shortcut icon",
      type: "image/x-icon",
      href: favIcon,
    },
  ],
};
